import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-science',
  templateUrl: './home-science.component.html',
  styleUrls: ['./home-science.component.scss']
})
export class HomeScienceComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
